<template>
    <el-dialog
        style="padding: 0 20px 20px 20px !important;"
        width="80%"
        :title="info.asin + '评价情况'"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form ref="ruleForm" :inline="true" class="query-form" size="mini" :model="query">
            <el-form-item label="星级：" class="query-form-item">
                <el-select v-model="query.star" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            border
            style="width: 98%;margin-top: 10px"
        >
            <el-table-column label="ID" align="center" width="50">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="星级" align="center" width="50">
                <template slot-scope="scope">
                    <div>{{ scope.row.star }}</div>
                </template>
            </el-table-column>

            <el-table-column label="用户" align="center" width="140">
                <template slot-scope="scope">
                    <div>{{ scope.row.profile_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="时间地点" align="center" width="180">
                <template slot-scope="scope">
                    <div>{{ scope.row.time_and_place }}</div>
                </template>
            </el-table-column>
            <el-table-column label="标题" align="center" width="250">
                <template slot-scope="scope">
                    <div>{{ scope.row.title }}</div>
                </template>
            </el-table-column>

            <el-table-column label="内容" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.content }}</div>
                </template>
            </el-table-column>
            <el-table-column label="爬取时间" align="center" width="140">
                <template slot-scope="scope">
                    <div>{{ scope.row.created_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="跳转链接" align="center" width="80">
                <template slot-scope="scope">
                    <el-button type="primary" @click.stop="edirectToAsin(scope.row)" size="mini">跳转</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :current-page="query.page"
                :page-sizes="[10, 50, 100]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; margin-bottom: 5px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
        </el-row>
        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息"
                   v-if="errorInfoShow"
                   :visible.sync="errorInfoShow" append-to-body>
            <span style="color: red">错误内容：</span>
            <span>{{ errorMsg }}</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
			</span>
        </el-dialog>

        <el-dialog width="30%" center title="添加店铺名称" :visible.sync="addNameModal" append-to-body>
            <el-form :inline="true" class="query-form" size="mini">

                <el-form-item label="店铺名称：" class="query-form-item" style="margin: 20px 0 10px">
                    <el-input
                        v-model="add_shop_name"
                        placeholder="请输入店铺名称"
                        style="width: 200px;"
                    ></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer">
				<el-button type="primary" @click="onAdd" size="mini">取 消</el-button>
				<el-button type="primary" @click="onAdd(true)" size="mini">添 加</el-button>
			</span>
        </el-dialog>
    </el-dialog>
</template>

<script>
import * as api from '@/api/Product/Product'
import {downloadFileUrl} from '@/utils/method'
import {sub_get_sub_asin_negative_comment_list_list} from '@/api/Product/Product'

export default {
    components: {},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        info: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            options: [{
                value: 1,
                label: '1星'
            }, {
                value: 2,
                label: '2星'
            }, {
                value: 3,
                label: '3星'
            }, {
                value: 4,
                label: '4星'
            }, {
                value: 5,
                label: '5星'
            },],
            add_shop_name: '',
            addNameModal: false,
            errorInfoShow: false,
            tableHeight: null,
            query: {
                page: 1,
                id: '',
                limit: 10,
                star: '',
            },
            loading: false,
            errorMsg: '',
            currentId: '',
            ctrl: {
                addRecordDialogVisible: false
            },
            list: [],
        }
    },
    watch: {
        'visible': {
            handler(flag) {
                if (flag) {
                    this.query.id = this.info.id
                    this.getList()
                }
            },
            deep: true
        }
    },
    methods: {
        edirectToAsin(data) {
            window.open(data.href_link, '_blank')
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        onAdd(flag) {
            if (flag) {
                api.shop_name_add({shop_name: this.add_shop_name}).then((res) => {
                    if (res.success) {
                        this.$message.success('添加成功')
                        this.getList()
                    } else {
                        this.$message.success(res.message)
                    }
                })
            }
            this.add_shop_name = ''
            this.addNameModal = false
        },
        delItemName(data) {
            this.$confirm('确认删除该店铺名称吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.shop_name_delete({id: data.id}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        onReset() {
            this.$set(this, 'query', {type: 'SB'})
            this.query.page = 1
            this.query.limit = 20
            this.getList()
        },
        searchForm() {
            this.getList()
        },
        showErrorInfo(info) {
            this.errorInfoShow = true
            this.errorMsg = info.err_smg
        },
        getList() {
            this.loading = true
            api.sub_get_sub_asin_negative_comment_list_list(this.query).then(res => {
                if (res.code === 0) {
                    this.list = res.data.list
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.$emit('close-callback', isshow)
        },
        addRecords() {
            this.ctrl.addRecordDialogVisible = true
        },
        delete_records(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.out_three_page_delete({id: data.id}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        closeCllback() {
            this.ctrl.addRecordDialogVisible = false
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        downFile(path) {
            if (!path) {
                return this.$message({type: 'error', message: '无法下载！'})
            }
            downloadFileUrl(path)
        },
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-card__header {
    padding: 14px 20px !important;
}

/deep/ .el-tabs__content {
    overflow: visible !important;
}

/deep/ .el-card {
    overflow: visible !important;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
